export const SUNDAY = 7;
